var shadowColorDark = "rgba(0, 0, 0, 0.35)";
var shadowColor = "rgba(18, 18, 18, 0.18)";
var shadowColorLight = "rgba(18, 18, 18, 0.15)";
export var shadows = {
  annular: "0px 1px 4px 0px ".concat(shadowColorLight),
  partial: "0px 2px 8px 0px ".concat(shadowColorLight),
  hybrid: "0px 3px 12px 0px ".concat(shadowColor),
  dusk: "0px 8px 20px 0px ".concat(shadowColorDark)
};